import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BookingService } from '@clooper/core';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-resend-receipt',
  templateUrl: './resend-receipt.component.html',
  styleUrls: ['./resend-receipt.component.scss']
})
export class ResendReceiptComponent implements OnInit {
  requestSent = false;
  icons = {
    cancel: faTimes
  }
  id: any;
  loading = false;

  constructor(
    public bsModalRef: BsModalRef,
    private booking: BookingService,
    private router: ActivatedRoute,
    public options: ModalOptions

  ) { 

    this.id = this.options?.initialState?.id
  }

  ngOnInit(): void {
    
  }



  resend() {
    this.loading = true;

    this.booking.resendBookingConfirmation(this.id, {}).subscribe((res: any) => {
      this.loading = false
      if (res) {

        this.requestSent = true;
      }
    })
    }

}
